import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    TextField,
    DateField,
    BooleanField,
    ReferenceField,
    FunctionField,
    UrlField,
} from 'react-admin';
import { Chip, Box, Button } from '@material-ui/core';
import {
    GetApp as DownloadIcon,
    Visibility as ViewIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    tab: {
        maxWidth: '100%',
    },
    actionButtons: {
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
    },
}));

const UserDocumentShow = (props: any) => {
    const classes = useStyles();

    const handleDownload = async (fileUrl: string, fileName: string) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const handleView = (fileUrl: string) => {
        window.open(fileUrl, '_blank');
    };

    return (
        <Show {...props}>
            <TabbedShowLayout>
                <Tab label="Summary" className={classes.tab}>
                    <TextField source="id" />
                    <ReferenceField
                        source="userId"
                        reference="users"
                        link="show"
                    >
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="documentType" />
                    <TextField source="documentNumber" />
                    <DateField source="expiryDate" />
                    <TextField source="description" />

                    <FunctionField
                        label="Verified Status"
                        render={(record: any) =>
                            record.isVerified ? (
                                <Chip
                                    label="Verified"
                                    color="primary"
                                    size="small"
                                />
                            ) : (
                                <Chip label="Not Verified" size="small" />
                            )
                        }
                    />

                    <ReferenceField
                        source="verifiedBy"
                        reference="users"
                        link="show"
                        label="Verified By"
                    >
                        <TextField source="name" />
                    </ReferenceField>

                    <DateField
                        source="verifiedAt"
                        showTime
                        label="Verified At"
                    />
                    <DateField source="createdAt" showTime />
                    <DateField source="updatedAt" showTime />
                </Tab>

                <Tab label="File" path="file" className={classes.tab}>
                    <TextField source="fileName" />
                    <FunctionField
                        label="File Size"
                        render={(record: any) =>
                            record.fileSize
                                ? `${(record.fileSize / 1024).toFixed(2)} KB`
                                : '-'
                        }
                    />
                    <TextField source="mimetype" />
                    <UrlField source="fileUrl" label="File URL" />

                    <FunctionField
                        label="Actions"
                        render={(record: any) =>
                            record.fileUrl ? (
                                <Box className={classes.actionButtons}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<ViewIcon />}
                                        onClick={() =>
                                            handleView(record.fileUrl)
                                        }
                                    >
                                        View PDF
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<DownloadIcon />}
                                        onClick={() =>
                                            handleDownload(
                                                record.fileUrl,
                                                record.fileName ||
                                                    'document.pdf'
                                            )
                                        }
                                    >
                                        Download
                                    </Button>
                                </Box>
                            ) : (
                                <span style={{ color: '#999' }}>
                                    No file uploaded
                                </span>
                            )
                        }
                    />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

export default UserDocumentShow;
